import React, { useState } from 'react';
import { GradientBorder } from 'components/common/GradientBorder';
import { gradients } from 'theme/tokens';
import { useAuthStore } from 'store/useAuthStore';
import { ApiError } from 'api/restClient';
import './loginScreen.css';

/** Full-screen login gate. Authenticates against the same backend the mobile
 *  app uses so analyses are attributed to the logged-in user. */
export function LoginScreen() {
  const signIn = useAuthStore((s) => s.signIn);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await signIn(username.trim(), password);
    } catch (err) {
      const msg =
        err instanceof ApiError
          ? err.status === 401
            ? 'Invalid username or password.'
            : `${err.message} (${err.status})`
          : err instanceof Error
            ? err.message
            : 'Login failed.';
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <GradientBorder colors={gradients.borderDefault} borderRadius={16} borderWidth={2}>
        <form className="login-card" onSubmit={onSubmit}>
          <div className="login-brand">NoBrainer</div>
          <div className="login-sub">Analysis Debug · sign in</div>

          <label className="login-field">
            <span className="login-label">Username or email</span>
            <input
              className="login-input"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              required
            />
          </label>

          <label className="login-field">
            <span className="login-label">Password</span>
            <input
              className="login-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          {error && <div className="login-error">{error}</div>}

          <button className="login-submit" type="submit" disabled={busy || !username || !password}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </GradientBorder>
    </div>
  );
}
